import { useEffect, useState } from 'react';

export default function useCalendarPreferences(defaultMode = 'single') {
    const [cyclicEnabled, setCyclicEnabled] = useState(false);
    const [autoAssignEnabled, setAutoAssignEnabled] = useState(false);
    const [mode, setMode] = useState(defaultMode);
  
    useEffect(() => {
      const storedPrefs = localStorage.getItem('calendarPreferences');
      if (storedPrefs) {
        try {
          const parsed = JSON.parse(storedPrefs);
          setCyclicEnabled(!!parsed.cyclicEnabled);
          setAutoAssignEnabled(!!parsed.autoAssignEnabled);
          setMode(parsed.cyclicEnabled ? 'cyclic' : 'single');
        } catch (err) {
          console.error("Błąd ładowania preferencji z localStorage:", err);
        }
      }
    }, []);
  
    const applyPreferences = () => {
      localStorage.setItem('calendarPreferences', JSON.stringify({
        cyclicEnabled,
        autoAssignEnabled
      }));
      setMode(cyclicEnabled ? 'cyclic' : 'single');
    };
  
    const resetPreferences = () => {
      setCyclicEnabled(false);
      setAutoAssignEnabled(false);
      setMode('single');
      localStorage.removeItem('calendarPreferences');
    };
  
    return {
      cyclicEnabled,
      setCyclicEnabled,
      autoAssignEnabled,
      setAutoAssignEnabled,
      mode,
      setMode,
      applyPreferences,
      resetPreferences
    };
  }